import { useQuery } from '@tanstack/react-query';
import { useApiClient } from '../../../apiClient';

export type WhatsAppGroupInviteLinkResponse = {
    groupId: string;
    inviteLink: string;
};

export const useGetWhatsAppGroupInviteLink = (
    organizationId: string,
    groupId: string,
    enabled: boolean,
) => {
    const apiClient = useApiClient();

    return useQuery<WhatsAppGroupInviteLinkResponse>({
        queryKey: ['organization', organizationId, 'whatsappGroupInviteLink', groupId],
        queryFn: () =>
            apiClient.fetchApi<WhatsAppGroupInviteLinkResponse, {}>({
                method: 'GET',
                endpoint: `organizations/${organizationId}/whatsapp-groups/${encodeURIComponent(groupId)}/invite-link`,
            }),
        enabled: !!organizationId && !!groupId && enabled,
    });
};
